import gql from "graphql-tag";
import RankedIssuerFields from "lib/fragments/RankedIssuerFields";
import TrailingReturnsFields from "lib/graphql/fragments/TrailingReturnsFields";

export default gql`
  fragment AmericanCompanyIssuerTopLevel on AmericanCompanyIssuer {
    _id
    irs
    name
    sector
    isREIT
    exchange
    listingExchange
    businessDescription
    shortBusinessDescription
    tickerSymbols
    tickerSymbolPrefix
    primaryTickerSymbol
    isAmericanDepositaryReceipt
    viewerDidBookmark
    websiteHref
    investorRelationsHref
    edgarHref
    foundedYear
    ipoDate
    standardAndPoorsIndicator
    engagementStats {
      totalDiscussionsCommentsCount
      viewerUnseenDiscussionsCommentsCount
    }
    employeeNumbers {
      totalOfEmployees
      asOfDate
    }
    isInPortfolio
    marketCapitalization {
      totalCapitalization
      asOfDate
    }
    countryCode
    securities {
      tickerSymbol
      investmentType
      ipoDate
      depositoryReceiptRatio
      trailingReturns {
        ...TrailingReturnsFields
      }
    }
    standardLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    niceLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    ...RankedIssuerFields
    youtubeVideos {
      ...YouTubeVideoFields
    }
    nareitClassification {
      investmentSector
      propertySector
      propertySubsector
    }
  }

  ${RankedIssuerFields}
  ${TrailingReturnsFields}
`;
